import { Link } from '@ecomm/framework/Link'
import { Trans } from '@ecomm/i18n'
import { useTranslation } from '@ecomm/i18n'
import { ComparisonCell } from '../ComparisonCell'
import { ComparisonRow } from '../ComparisonRow'

export function RowAntiTheft() {
  const { t } = useTranslation('maps')

  return (
    <ComparisonRow
      title={t('feature-title.anti-theft')}
      description={t('feature-description.anti-theft')}
      modalDescription={
        <Trans
          t={t}
          i18nKey="feature-tooltip.anti-theft"
          components={{
            termsLink: (
              <Link
                className="text-inherit hover:no-underline"
                to="/terms-of-service"
              >
                text
              </Link>
            )
          }}
        />
      }
    >
      <ComparisonCell included={false} />
      <ComparisonCell included={true} />
      <ComparisonCell included={true} />
    </ComparisonRow>
  )
}
